export const removeContextMenu = (): void => {
  window.oncontextmenu = function (event: Event) {
    event.preventDefault();
    event.stopPropagation();
    return false;
  };
};
